"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _createForOfIteratorHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createForOfIteratorHelper"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _recorderAzure = _interopRequireDefault(require("./recorder-azure"));

var _MicroImage = _interopRequireDefault(require("./MicroImage"));

require("./Micro.css");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var global_blob;
var recorder = new _recorderAzure.default({
  onRecordingStop: function onRecordingStop(blob) {
    global_blob = blob;
  },
  onRecording: function onRecording() {},
  visualizer: [true, true]
});

function Micro(_ref) {
  var parentHandler = _ref.parentHandler,
      language = _ref.language,
      color = _ref.color,
      maxTime = _ref.maxTime,
      brand = _ref.brand,
      modelEndpointId = _ref.modelEndpointId;

  var _useState = (0, _react.useState)('pre'),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      recordingState = _useState2[0],
      setRecordingState = _useState2[1];

  var _useState3 = (0, _react.useState)({}),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      micData = _useState4[0],
      setMicData = _useState4[1];

  var _useState5 = (0, _react.useState)(10),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      fontSize = _useState6[0],
      setFontSize = _useState6[1];

  var _useState7 = (0, _react.useState)(maxTime),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      time = _useState8[0],
      setTime = _useState8[1];

  var container = (0, _react.useRef)( /*#__PURE__*/_react.default.createElement("p", null));
  var wave1 = (0, _react.useRef)();
  var wave2 = (0, _react.useRef)();
  window.modelEndpointId = modelEndpointId;
  recorder.brand = brand;
  recorder.get_auth_token();

  if (maxTime && recordingState == 'recording') {
    setTimeout(function () {
      return setTime(time - 1);
    }, 1000);
  }

  function getLanguage(dict) {
    if (language) {
      return dict[language.substring(0, 2)];
    }

    if (typeof dict === "string") {
      return dict;
    }

    var lgs = navigator.languages.map(function (x) {
      return x.substring(0, 2);
    });

    var _iterator = (0, _createForOfIteratorHelper2.default)(lgs),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var lg = _step.value;

        if (dict.hasOwnProperty(lg)) {
          return dict[lg];
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return dict[Object.keys(dict)[0]];
  }

  (0, _react.useEffect)(function () {
    setFontSize(0.1 * container.current.clientWidth);
    recorder.wave = [wave1, wave2];
  });
  (0, _react.useEffect)(function () {
    parentHandler(recordingState, micData, global_blob);
  }, [recordingState, micData]);

  var startRecording = function startRecording() {
    recorder.toggleRecording();
    return setRecordingState('recording');
  };

  var stopRecording = function stopRecording() {
    setRecordingState('loading');
    return recorder.toggleRecording().then(function (x) {
      setRecordingState('post');
      setMicData(x);
    }).catch(function () {
      return setRecordingState('pre');
    });
  };

  var different_states = {
    "pre": {
      "class": "pre_micro",
      "fonction": startRecording,
      "text": {
        "en": "Touch and speak",
        "fr": "Toucher puis parler"
      }
    },
    "recording": {
      "class": "recording_micro",
      "fonction": stopRecording,
      "text": {
        "en": "Touch to send!",
        "fr": "Toucher pour envoyer !"
      }
    },
    "loading": {
      "class": "loading_micro",
      "fonction": function fonction() {},
      "text": {
        "en": "Sending in progress ...",
        "fr": "Envoi en cours ..."
      }
    },
    "post": {
      "class": "finished_micro",
      "fonction": function fonction() {},
      "text": ""
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      textAlign: "center"
    },
    ref: container
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "micro_container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: "60%"
    },
    onClick: different_states[recordingState]['fonction'],
    className: "micro_img " + different_states[recordingState]['class']
  }, /*#__PURE__*/_react.default.createElement(_MicroImage.default, {
    size: "100%",
    color: color
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "wave_container " + (recordingState === 'recording' ? 'wave_appear' : '')
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "wave1",
    ref: wave1
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "wave2",
    ref: wave2
  }))), /*#__PURE__*/_react.default.createElement("p", {
    className: "micro_label",
    style: {
      fontSize: fontSize + 'px'
    }
  }, getLanguage(different_states[recordingState]['text'])), /*#__PURE__*/_react.default.createElement("p", {
    className: "micro_label",
    style: {
      color: time < 0 ? 'red' : 'black',
      fontSize: fontSize + 'px'
    }
  }, maxTime && recordingState == 'recording' ? time + 's' : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "\xA0")));
}

var _default = Micro;
exports.default = _default;